import(/* webpackMode: "eager" */ "/codebuild/output/src1293906955/src/openmenu-frontend/app/orders/[id]/page.jsx");
